import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";

const ManagedCampaignCreatePageRedesign: FC = () => (
  <CampaignBuilderForm mode="campaign" campaignPlayType={CAMPAIGN_PLAY_TYPE.MANAGED} visibleOptionalPanels={[]} />
);

export default ManagedCampaignCreatePageRedesign;
